export default "/images/f2293f20c44b8b0e36af2f10a6f75dbc.avif";